export const translations = {
  ca: {
    nav: {
      home: 'INICI',
      what: 'QUÈ SÓN LES CONSTEL·LACIONS FAMILIARS',
      where: 'ON',
      retreats: 'RETIRS',
      about: 'SOBRE MI',
      contact: 'CONTACTE',
      cta: 'Parlem',
      brand_tagline: 'Constel·lacions Familiars',
    },
    hero: {
      name: 'Georgina Fahle Ruiz',
      role: 'Constel·lacions Familiars',
      title1: 'Vols posar més llum',
      title2: 'en el teu camí?',
      subtitle:
        "Descobreix les constel·lacions familiars per alliberar els patrons que t'impedeixen avançar i brillar plenament.",
      questions: [
        'Vols canviar aspectes de la teva vida?',
        'Vols posar ordre i equilibri en alguna situació que et preocupa?',
        'Vols millorar alguna relació?',
        "Vols veure les coses d'una manera diferent i amb més consciència?",
      ],
      benefits_intro:
        "Les constel·lacions familiars són una eina terapèutica i d'autoconeixement que t'ajuda a…",
      benefits: [
        'Identificar i transformar patrons inconscients i bloquejos emocionals.',
        "Comprendre l'arrel del conflicte actual.",
        'Descobrir càrregues familiars heretades que influeixen en la teva vida present.',
        'Alliberar-te emocionalment per sentir claredat i pau.',
        'Viure amb més consciència, equilibri i connexió amb tu mateix/a i amb les teves relacions.',
      ],
      cta: 'SABER-NE MÉS',
      quote: 'Sanar no és canviar el passat, és reconciliar-se amb ell.',
      author: '— Bert Hellinger',
    },
    talleres_intro:
      "Les Constel·lacions Familiars grupals són una experiència terapèutica en la qual, a través de la representació i la visió sistèmica, les dinàmiques ocultes del teu sistema familiar es fan visibles. Explorem d'una manera amorosa i respectuosa per sentir la pau i felicitat que mereixes.",
    experience: {
      title: 'Què trobaràs als meus tallers?',
      pillars: [
        'Naturalitat i confiança',
        'Espai segur i respectuós',
        'Professionalitat',
      ],
      p1: "Tant si portes un tema com a protagonista de la teva constel·lació, com si participes com a representant en les d'altres persones, cada persona rep un aprenentatge interior.",
      highlight: 'AQUESTA ÉS LA MÀGIA DEL TREBALL EN GRUP',
      p2: 'No cal que facis res perfectament. No cal que sàpigues com funciona. Només cal que apareguis i et permetis ser rebut/da.',
    },
    benefits_section: {
      title: "El que t'emportaràs",
      intro:
        'Això no tracta del que aprendràs. Tracta del que sentiràs. I del que pot canviar.',
      items: [
        "Pau amb una relació familiar que t'ha causat dolor.",
        'Claredat sobre un patró que has estat repetint.',
        'Un nou lloc en el teu sistema familiar: de pertinença, no de càrrega.',
        'Alleujament per no continuar carregant un pes que no era teu.',
        'Una manera diferent de veure la teva història: amb més amor i menys judici.',
        'Moviment que desbloqueja el bloqueig.',
      ],
    },
    foryou: {
      title_yes: 'Això és per a tu si...',
      title_no: 'Això no és per a tu si...',
      yes: [
        'Sents que repeteixes patrons per molt que intentis canviar',
        'Tens relacions complicades i vols trobar pau',
        'Sents que portes alguna cosa pesada però no saps com anomenar-la',
        "Sents un buit dins teu que no saps d'on ve",
        "Estàs obert/a a veure la teva situació des d'una perspectiva nova i sistèmica.",
        'Vols una experiència real i viscuda, no només informació',
        "Estàs preparat/da per fer espai a noves maneres d'actuar i sentir dins teu.",
      ],
      no: [
        'Estàs buscant una solució ràpida sense obertura personal',
        'Estàs completament tancat/da a explorar la teva història familiar.',
        "Vols observar des de la distància sense voluntat d'estar present",
        'Vols informació a la qual no tenim permís per accedir (no és el tarot ni la bola màgica).',
      ],
      disclaimer: '(I això està bé — hi ha un moment per a tot.)',
    },
    final: {
      quote: "Perquè l'amor flueixi ha d'haver-hi ordre.",
      author: '— Bert Hellinger',
      title: "Vols que t'acompanyi en aquest camí d'obertura i claredat?",
      btn_wa: 'WhatsApp',
      btn_phone: "Truca'm",
      link: "Contacta'm →",
    },
    about: {
      quote:
        'El meu projecte és acompanyar les persones en els seus processos de vida a través de les Constel·lacions Familiars.',
      name: 'Georgina Fahle Ruiz',
      title:
        'Terapeuta i facilitadora certificada en Constel·lacions Familiars',
      p1: 'Des de sempre va existir en mi un anhel per descobrir allò que no podem veure amb els ulls, que només podem sentir.',
      p2: 'Als 17 anys llegia llibres de creixement personal i espiritual i, als 22, vaig començar a formar-me en diverses eines terapèutiques com la bioneuroemoció, ThetaHealing, Saama, la Teràpia de Resposta Espiritual, entre altres.',
      p3: 'Les constel·lacions familiars van arribar a la meva vida en un camí de recerca per millorar la meva vida i les meves relacions. Em vaig formar en constel·lacions familiars durant 2 anys a Barcelona i, durant aquest temps, vaig anar transformant la meva realitat, posant ordre i amor en el meu sistema familiar i canviant patrons de conducta negatius per tenir una vida més plena.',
      p4: "Com aquesta eina terapèutica em va ajudar tant, vaig voler compartir-la amb altres persones, acompanyant-les a sanar el seu llinatge i els seus patrons repetitius perquè puguin veure i sentir la seva realitat d'una altra manera, transformar-la i sentir-se millor amb elles mateixes i el seu entorn.",
      q: "Vols ser una d'elles? T'acompanyo en el teu procés.",
      cta: "CONTACTA'M",
    },
    whatare: {
      title: 'Què són les Constel·lacions Familiars?',
      top_quote: "Perquè l'amor flueixi ha d'haver-hi ordre.",
      top_author: '— Bert Hellinger',
      paragraphs: [
        "Les constel·lacions familiars són una eina terapèutica i d'autoconeixement que et permet descobrir, comprendre i transformar patrons inconscients que poden estar influint en la teva vida actual. Moltes vegades portem emocions, creences, bloquejos o maneres de relacionar-nos que no neixen únicament de les nostres experiències personals, sinó també d'històries familiars, vivències dels nostres avantpassats o situacions que van deixar una empremta profunda en el sistema familiar.",
        "En les constel·lacions grupals que realitzo, el treball es desenvolupa dins d'un grup de persones. La persona que constel·la exposa breument el tema que vol treballar i, amb el meu acompanyament, tria diferents participants per representar membres de la seva família, aspectes interns o elements importants relacionats amb la situació que vol tractar. A partir d'aquí comença una representació viva on surten a la llum dinàmiques inconscients, emocions ocultes i vincles profunds que estaven actuant de fons sense que poguessis veure-ho clarament.",
        "La constel·lació permet observar des d'on t'estàs vinculant amb altres persones i també amb tu mateix/a. Moltes vegades descobrim que repetim patrons heretats, que ocupem llocs que no ens corresponen dins del sistema familiar o que estem carregant dolors, pors o responsabilitats que pertanyen a generacions anteriors.",
        "Quan aquestes dinàmiques surten a la llum, pots començar a comprendre l'origen profund de moltes situacions que vius en el present. El que abans era inconscient comença a veure's amb claredat. I quan posem llum on abans hi havia dolor ocult o confusió, apareix una nova comprensió que obre espai per a la pau, l'amor i la transformació.",
        "Durant la constel·lació, a través de l'escenificació i de diferents moviments i frases sanadores, es va creant un nou ordre intern. Aquestes frases ajuden a reconèixer el viscut, honorar la història familiar i alliberar càrregues emocionals o lleialitats inconscients que ja no necessites continuar sostenint. No es tracta d'esborrar el passat, sinó de mirar-lo amb respecte per poder col·locar-te en la teva vida d'una forma més lliure, conscient i en pau.",
        "Cada procés és únic, perquè cada persona i cada història familiar tenen el seu propi camí. De vegades els canvis són profunds i visibles ràpidament, i d'altres vegades la informació continua integrant-se a poc a poc amb el temps. El important és que la constel·lació obre una porta per mirar la teva vida des d'una altra perspectiva i permetre que allò que estava bloquejat pugui començar a transformar-se.",
        "Les constel·lacions familiars t'inviten a mirar amb amor la teva història, reconèixer allò que necessites deixar enrere i prendre la força del teu sistema familiar per avançar amb més consciència, benestar i presència en la teva vida actual. Perquè quan comprens d'on venen certes càrregues o patrons, pots començar a triar d'una manera més lliure com vols viure, relacionar-te i sentir-te amb tu mateix/a i amb els altres.",
      ],
      difficulties_title:
        'A través de les constel·lacions familiars pots mirar amb més claredat allò que avui et genera dificultat:',
      difficulties: [
        'Relacions de parella',
        'Conflictes familiars: pare, mare, fills/es',
        'Problemes laborals',
        'Manca de confiança',
        'Pors',
        "Manca d'abundància",
        'Ansietat i sensació de buit',
        'Maternitat i paternitat',
        'Sexualitat',
        'Hàbits i conductes negatives',
      ],
      after_title: "Moltes persones senten després d'una constel·lació:",
      after: [
        'Més claredat',
        'Alleujament emocional',
        'Connexió amb elles mateixes',
        'Més pau i tranquil·litat interior',
      ],
      overlay:
        'Quan posem llum on hi havia dolor ocult, apareix una nova comprensió.',
      georgina_quote:
        'El meu projecte és acompanyar les persones en els seus processos de vida a través de les Constel·lacions Familiars.',
      georgina_author: '— Georgina Fahle Ruiz',
      cta: 'CONTACTE',
    },
    where: {
      title: 'VINE ALS TALLERS DE CONSTEL·LACIONS FAMILIARS A:',
      main_location: 'VILAFRANCA DEL PENEDÈS, DE MANERA REGULAR',
      also_label: 'També a:',
      locations: ['Altres pobles propers', 'Igualada', 'Manresa', 'Tarragona'],
      p3: "Si estàs interessat/da que vagi al teu poble o ciutat a realitzar un taller, posa't en contacte amb mi.",
      p4: "O si tens un centre terapèutic i vols oferir aquesta eina al teu espai i busques una professional, contacta'm i ho parlem.",
      btn_wa: 'Rebre informació dels propers tallers',
      cta: "CONTACTA'M",
    },
    retiros: {
      title: 'Retirs a Casa Cal Faro',
      p1: 'Casa Cal Faro és la casa de retirs que coordino on acollim grups de retirs espirituals i de creixement personal i interior. A Cal Faro rebem grups de formacions, cursos i esdeveniments. Tot això per desconnectar de la vida rutinària de cada persona i poder endinsar-se en les meravelles que ofereix la naturalesa que ens envolta i el treball interior que es realitzi en cada retir.',
      p2: "Cal Faro és una casa gran entre boscos i muntanya, als afores de la població de La Llacuna (40 min de Vilafranca del Penedès). És una casa completament reformada i amb molt d'encant on poder trobar la pau i tranquil·litat que necessites.",
      p3: "A Cal Faro organitzo retirs de constel·lacions familiars on podràs entrar d'una manera molt més profunda en el teu interior per convertir la teva vida en el camí que desitges crear.",
      btn1: 'DESCOBREIX CASA CAL FARO',
      btn2: 'DESCOBREIX ELS RETIRS DE CASA CAL FARO',
      btn1_link: 'https://www.casacalfaro.com',
      btn2_link: 'https://www.casacalfaro.com/proximos-retiros',
      closing: "T'espero aviat a Cal Faro",
    },
    contact: {
      title: 'Contacte',
      name: 'Georgina Fahle Ruiz',
      form_title:
        'Omple el formulari per rebre les dates i llocs dels propers tallers de constel·lacions familiars:',
      f_name: 'Nom i cognoms *',
      f_phone: 'Telèfon *',
      f_email: 'Email *',
      f_obs: 'Observacions',
      obs_placeholder:
        'Vull rebre les dates i localitzacions dels propers tallers de constel·lacions familiars.',
      check2: 'He llegit i accepto la política de cookies i de privacitat. *',
      submit: 'ENVIAR',
      legal: 'Avís legal',
      privacy: 'Avís de privacitat',
      cookies: 'Avís de cookies',
    },
    footer: {
      tagline:
        'Acompanyant persones en el seu camí a través de les Constel·lacions Familiars',
      nav: ['Inici', 'Què són', 'On', 'Retirs', 'Sobre mi', 'Contacte'],
      copy: '© 2025 Georgina Constelacions · www.georginaconstelaciones.com',
      legal: 'Avís legal · Privacitat · Cookies',
      nav_label: 'Navegació',
      social_label: 'Segueix-me',
      legal_links: [
        'Avís Legal',
        'Política de Privacitat',
        'Política de Cookies',
      ],
    },
  },
  es: {
    nav: {
      home: 'INICIO',
      what: 'QUÉ SON LAS CONSTELACIONES FAMILIARES',
      where: 'DÓNDE',
      retreats: 'RETIROS',
      about: 'SOBRE MÍ',
      contact: 'CONTACTO',
      cta: 'Hablemos',
      brand_tagline: 'Constelaciones Familiares',
    },
    hero: {
      name: 'Georgina Fahle Ruiz',
      role: 'Constelaciones Familiares',
      title1: '¿Quieres poner más luz',
      title2: 'en tu camino?',
      subtitle:
        'Descubre las constelaciones familiares para liberar los patrones que te impiden avanzar y brillar plenamente.',
      questions: [
        '¿Quieres cambiar aspectos de tu vida?',
        '¿Quieres poner orden y equilibrio en alguna situación que te preocupa?',
        '¿Quieres mejorar alguna relación?',
        '¿Quieres ver las cosas de una manera diferente y con más consciencia?',
      ],
      benefits_intro:
        'Las constelaciones familiares son una herramienta terapéutica y de autoconocimiento que te ayuda a…',
      benefits: [
        'Identificar y transformar patrones inconscientes y bloqueos emocionales.',
        'Comprender la raíz del conflicto actual.',
        'Descubrir cargas familiares heredadas que influyen en tu vida presente.',
        'Liberarte emocionalmente para sentir claridad y paz.',
        'Vivir con más consciencia, equilibrio y conexión contigo mismo/a y con tus relaciones.',
      ],
      cta: 'SABER MÁS',
      quote: 'Sanar no es cambiar el pasado, es reconciliarse con él.',
      author: '— Bert Hellinger',
    },
    talleres_intro:
      'Las Constelaciones Familiares grupales son una experiencia terapéutica en la que, a través de la representación y la visión sistémica, las dinámicas ocultas de tu sistema familiar se hacen visibles. Exploramos de una manera amorosa y respetuosa para sentir la paz y felicidad que mereces.',
    experience: {
      title: '¿Qué encontrarás en mis talleres?',
      pillars: [
        'Naturalidad y confianza',
        'Espacio seguro y respetuoso',
        'Profesionalidad',
      ],
      p1: 'Tanto si llevas un tema como protagonista de tu constelación, como si participas como representante en las de otras personas, cada persona recibe una enseñanza en su interior.',
      highlight: 'ESTA ES LA MAGIA DEL TRABAJO EN GRUPO',
      p2: 'No hace falta que hagas nada perfectamente. No hace falta que sepas cómo funciona. Solo hace falta que aparezcas y te permitas ser recibido/a.',
    },
    benefits_section: {
      title: 'Lo que te llevarás',
      intro:
        'Esto no trata de lo que aprenderás. Trata de lo que sentirás. Y de lo que puede cambiar.',
      items: [
        'Paz con una relación familiar que te ha causado dolor.',
        'Claridad sobre un patrón que has estado repitiendo.',
        'Un nuevo lugar en tu sistema familiar: de pertenencia, no de carga.',
        'Alivio por no seguir cargando un peso que no era tuyo.',
        'Una manera diferente de ver tu historia: con más amor y menos juicio.',
        'Movimiento que desbloquea el bloqueo.',
      ],
    },
    foryou: {
      title_yes: 'Esto es para ti si...',
      title_no: 'Esto no es para ti si...',
      yes: [
        'Sientes que repites patrones por mucho que intentes cambiar',
        'Tienes relaciones complicadas y quieres encontrar paz',
        'Sientes que llevas algo pesado pero no sabes cómo nombrarlo',
        'Sientes un vacío dentro de ti que no sabes de dónde viene',
        'Estás abierto/a a ver tu situación desde una perspectiva nueva y sistémica.',
        'Quieres una experiencia real y vivida, no solo información',
        'Estás preparado/a para hacer espacio a nuevas maneras de actuar y sentir dentro de ti.',
      ],
      no: [
        'Estás buscando una solución rápida sin apertura personal',
        'Estás completamente cerrado/a a explorar tu historia familiar.',
        'Quieres observar desde la distancia sin voluntad de estar presente',
        'Quieres información a la que no tenemos permiso para acceder (no es el tarot ni la bola mágica).',
      ],
      disclaimer: '(Y esto está bien — hay un momento para todo.)',
    },
    final: {
      quote: 'Para que fluya el amor tiene que haber orden.',
      author: '— Bert Hellinger',
      title: '¿Quieres que te acompañe en este camino de apertura y claridad?',
      btn_wa: 'WhatsApp',
      btn_phone: 'Llámame',
      link: 'Contáctame →',
    },
    about: {
      quote:
        'Mi proyecto es acompañar a las personas en sus procesos de vida a través de las Constelaciones Familiares.',
      name: 'Georgina Fahle Ruiz',
      title:
        'Terapeuta y facilitadora certificada en Constelaciones Familiares',
      p1: 'Desde siempre existió en mí un anhelo por descubrir aquello que no podemos ver con los ojos, que solamente podemos sentir.',
      p2: 'A los 17 años leía libros de crecimiento personal y espiritual y, a los 22, empecé a formarme en diversas herramientas terapéuticas como la bioneuroemoción, ThetaHealing, Saama, la Terapia de Respuesta Espiritual, entre otras.',
      p3: 'Las constelaciones familiares llegaron a mi vida en un camino de búsqueda para mejorar mi vida y mis relaciones. Me formé en constelaciones familiares durante 2 años en Barcelona y, durante este tiempo, fui transformando mi realidad, poniendo orden y amor en mi sistema familiar y cambiando patrones de conducta negativos para tener una vida más plena.',
      p4: 'Como esta herramienta terapéutica me ayudó tanto, quise compartirla con otras personas, acompañándolas a sanar su linaje y sus patrones repetitivos para que puedan ver y sentir su realidad de otra manera, transformarla y sentirse mejor consigo mismas y con su entorno.',
      q: '¿Quieres ser una de ellas? Te acompaño en tu proceso.',
      cta: 'CONTÁCTAME',
    },
    whatare: {
      title: '¿Qué son las Constelaciones Familiares?',
      top_quote: 'Para que el amor fluya tiene que haber orden.',
      top_author: '— Bert Hellinger',
      paragraphs: [
        'Las constelaciones familiares son una herramienta terapéutica y de autoconocimiento que te permite descubrir, comprender y transformar patrones inconscientes que pueden estar influyendo en tu vida actual. Muchas veces cargamos emociones, creencias, bloqueos o formas de relacionarnos que no nacen únicamente de nuestras experiencias personales, sino también de historias familiares, vivencias de nuestros antepasados o situaciones que dejaron una huella profunda en el sistema familiar.',
        'En las constelaciones grupales que realizo, el trabajo se desarrolla dentro de un grupo de personas. La persona que constela expone brevemente el tema que desea trabajar y, con mi acompañamiento, elige a diferentes participantes para representar miembros de su familia, aspectos internos o elementos importantes relacionados con la situación que quiere tratar. A partir de ahí comienza una representación viva donde salen a la luz dinámicas inconscientes, emociones ocultas y vínculos profundos que estaban actuando de fondo sin que pudieras verlo claramente.',
        'La constelación permite observar desde dónde te estás vinculando con otras personas y también contigo mismo/a. Muchas veces descubrimos que repetimos patrones heredados, que ocupamos lugares que no nos corresponden dentro del sistema familiar o que estamos cargando dolores, miedos o responsabilidades que pertenecen a generaciones anteriores.',
        'Cuando estas dinámicas salen a la luz, puedes empezar a comprender el origen profundo de muchas situaciones que vives en el presente. Lo que antes era inconsciente comienza a verse con claridad. Y cuando ponemos luz donde antes había dolor oculto o confusión, aparece una nueva comprensión que abre espacio para la paz, el amor y la transformación.',
        'Durante la constelación, a través de la escenificación y de diferentes movimientos y frases sanadoras, se va creando un nuevo orden interno. Estas frases ayudan a reconocer lo vivido, honrar la historia familiar y liberar cargas emocionales o lealtades inconscientes que ya no necesitas seguir sosteniendo. No se trata de borrar el pasado, sino de mirarlo con respeto para poder colocarte en tu vida de una forma más libre, consciente y en paz.',
        'Cada proceso es único, porque cada persona y cada historia familiar tienen su propio camino. A veces los cambios son profundos y visibles rápidamente, y otras veces la información sigue integrándose poco a poco con el tiempo. Lo importante es que la constelación abre una puerta para mirar tu vida desde otra perspectiva y permitir que aquello que estaba bloqueado pueda comenzar a transformarse.',
        'Las constelaciones familiares te invitan a mirar con amor tu historia, reconocer aquello que necesitas dejar atrás y tomar la fuerza de tu sistema familiar para avanzar con más consciencia, bienestar y presencia en tu vida actual. Porque cuando comprendes de dónde vienen ciertas cargas o patrones, puedes empezar a elegir de una manera más libre cómo quieres vivir, relacionarte y sentirte contigo mismo/a y con los demás.',
      ],
      difficulties_title:
        'A través de las constelaciones familiares puedes mirar con más claridad aquello que hoy te genera dificultad:',
      difficulties: [
        'Relaciones de pareja',
        'Conflictos familiares: padre, madre, hijos/as',
        'Problemas laborales',
        'Falta de confianza',
        'Miedos',
        'Falta de abundancia',
        'Ansiedad y sensación de vacío',
        'Maternidad y paternidad',
        'Sexualidad',
        'Hábitos y conductas negativas',
      ],
      after_title: 'Muchas personas sienten después de una constelación:',
      after: [
        'Más claridad',
        'Alivio emocional',
        'Conexión consigo mismas',
        'Más paz y tranquilidad interior',
      ],
      overlay:
        'Cuando ponemos luz donde había dolor oculto, aparece una nueva comprensión.',
      georgina_quote:
        'Mi proyecto es acompañar a las personas en sus procesos de vida a través de las Constelaciones Familiares.',
      georgina_author: '— Georgina Fahle Ruiz',
      cta: 'CONTACTO',
    },
    where: {
      title: 'VEN A LOS TALLERES DE CONSTELACIONES FAMILIARES EN:',
      main_location: 'VILAFRANCA DEL PENEDÈS, DE MANERA REGULAR',
      also_label: 'También en:',
      locations: ['Otros pueblos cercanos', 'Igualada', 'Manresa', 'Tarragona'],
      p3: 'Si estás interesado/a en que vaya a tu pueblo o ciudad a realizar un taller, ponte en contacto conmigo.',
      p4: 'O si tienes un centro terapéutico y quieres ofrecer esta herramienta en tu espacio y buscas una profesional, contáctame y lo hablamos.',
      btn_wa: 'Recibir información de próximos talleres',
      cta: 'CONTÁCTAME',
    },
    retiros: {
      title: 'Retiros en Casa Cal Faro',
      p1: 'Casa Cal Faro es la casa de retiros que coordino donde acogemos grupos de retiros espirituales y de crecimiento personal e interior. En Cal Faro recibimos grupos de formaciones, cursos y eventos. Todo ello para desconectar de la vida rutinaria de cada persona y poder adentrarse en las maravillas que ofrece la naturaleza que nos rodea y el trabajo interior que se realice en cada retiro.',
      p2: 'Cal Faro es una casa grande entre bosques y montaña, en las afueras de la población de La Llacuna (40 min de Vilafranca del Penedès). Es una casa completamente reformada y con mucho encanto donde poder encontrar la paz y tranquilidad que necesitas.',
      p3: 'En Cal Faro organizo retiros de constelaciones familiares donde podrás entrar de una manera mucho más profunda en tu interior para convertir tu vida en el camino que deseas crear.',
      btn1: 'DESCUBRE CASA CAL FARO',
      btn2: 'DESCUBRE LOS RETIROS DE CASA CAL FARO',
      btn1_link: 'https://www.casacalfaro.com',
      btn2_link: 'https://www.casacalfaro.com/proximos-retiros',
      closing: 'Te espero pronto en Cal Faro',
    },
    contact: {
      title: 'Contacto',
      name: 'Georgina Fahle Ruiz',
      form_title:
        'Rellena el formulario para recibir las fechas y lugares de los próximos talleres de constelaciones familiares:',
      f_name: 'Nombre y apellidos *',
      f_phone: 'Teléfono *',
      f_email: 'Email *',
      f_obs: 'Observaciones',
      obs_placeholder:
        'Quiero recibir las fechas y localizaciones de los próximos talleres de constelaciones familiares.',
      check2: 'He leído y acepto la política de cookies y de privacidad. *',
      submit: 'ENVIAR',
      legal: 'Aviso legal',
      privacy: 'Aviso de privacidad',
      cookies: 'Aviso de cookies',
    },
    footer: {
      tagline:
        'Acompañando personas en su camino a través de las Constelaciones Familiares',
      nav: ['Inicio', 'Qué son', 'Dónde', 'Retiros', 'Sobre mí', 'Contacto'],
      copy: '© 2025 Georgina Constelaciones · www.georginaconstelaciones.com',
      legal: 'Aviso legal · Privacidad · Cookies',
      nav_label: 'Navegación',
      social_label: 'Sígueme',
      legal_links: [
        'Aviso Legal',
        'Política de Privacidad',
        'Política de Cookies',
      ],
    },
  },
}
